<template>
  <div>
    <b-card-actions :title="$t('attendance.percentage')">
      <b-row>
        <b-col lg="12">
          <vue-apex-charts type="donut" height="350" :options="donutChart.chartOptions" :series="donutChart.series" v-if="donutChart.series" />
          <h4 class="text-center" v-else>جاري التحميل</h4>
        </b-col>
      </b-row>
    </b-card-actions>
    <b-card>
      <div class="row mb-3 mt-3">
        <div class="col-md-3"></div>
        <div class="col-md-6">
          <div class="form-group">
            <input v-model="search" type="text" autofocus class="form-control" :placeholder="$t(`site.search`)"
              @input="(val) => searchChange(val)" />
          </div>
        </div>
        <div class="col-3">
          <div class="float-md-right pt-1">
            <span class="text-muted text-small mr-1 mb-2">
              {{ from }}:{{ to }}
            </span>

            <b-dropdown id="ddown2" right :text="`${perPage}`" variant="outline-warning" size="xs">
              <b-dropdown-item v-for="(size, index) in [5, 10, 20, 50, 100]" :key="index" @click="changePageSize(size)">
                {{ size }}</b-dropdown-item>
            </b-dropdown>
            <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 overflow-auto">
          <b-table :stacked="($mobile==1)"  ref="table" class="vuetable" sort-by="start_in" sort-desc.sync="false" :current-page="currentPage"
            :fields="bootstrapTable.fields" :items="dataProvider">
            <template #cell(room_id)="data">
              {{ data.item.get_room.name }}
            </template>
            <template #cell(start_in)="data">
              <div>
                {{ GetDateTimeZone(data.item.online_class.start_in) }}
              </div>
            </template>
            <template #cell(end_in)="data">
              <div>
                {{ GetDateTimeZone(data.item.online_class.end_in) }}
              </div>
            </template>
            <template #cell(attendance)="data">
              <h6>
                <span class="badge badge-success d-block" v-if="attend(data.item)">{{ $t("attendance.attend") }}</span>
                <span class="badge badge-warning d-block" v-else-if="checkExcuse(data.item)">{{ $t("attendance.excuse")
                }}</span>
                <span class="badge badge-danger d-block" v-else>{{
                $t("attendance.absence")
                }}</span>
              </h6>
            </template>
            <template #cell(excuse_request)="data">
              <b-button v-if="!checkApologies(data.item)" v-b-modal.modal-info variant="outline-info"
                @click="sessionId = data.item.online_class.id">
                {{ $t("attendance.ask_for_excuse") }}
              </b-button>
              <b-button @click="getApologies(data.item)" variant="outline-primary" v-else>
                {{ $t("site.read") }}
              </b-button>
            </template>
          </b-table>
          <b-spinner v-if="load" type="grow" label="Loading..." class="loading" />
          <hr />
          <b-pagination v-model="currentPage" align="right"
            class="dataTables_paginate paging_simple_numbers pagination-warning" :total-rows="totalRows"
            :per-page="perPage">
            <template v-slot:next-text>
              <i class="fas fa-angle-left" />
            </template>
            <template v-slot:prev-text>
              <i class="fas fa-angle-right" />
            </template>
            <template v-slot:first-text>
              <i class="fas fa-step-forward" />
            </template>
            <template v-slot:last-text>
              <i class="fas fa-step-backward" />
            </template>
          </b-pagination>

          <!-- end of table -->
        </div>
        <!-- end of col -->
      </div>
      <!-- end of row -->
      <b-modal id="modal-info" ok-variant="info" :ok-title="$t('site.add')" :cancel-title="$t('site.cancel')"
       modal-class="modal-info" centered @ok="submit" size="lg"
        :title="$t('attendance.ask_for_excuse')">
        <validation-observer ref="registerForm" #default="{ invalid }">
          <b-form>
            <b-row>
              <b-col cols="12">
                <validation-provider #default="{ errors }" :name="$t('apology.reason')" vid="reason" rules="required">
                  <b-form-group class="mb-2">
                    <ckeditor :config="{ contentsLangDirection: 'rtl',versionCheck : false }" v-model="newData.reason"
                      :placeholder="$t('apology.reason')" :state="errors.length > 0 ? false : null" />
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>
      <b-modal ref="modal-primary" ok-only ok-title="ok" modal-class="modal-primary" centered>
        <b-card-text>
          <b-spinner v-if="loadStatus" type="grow" label="Loading..." class="loading" />

          <app-timeline>
            <app-timeline-item v-for="status in apologyStatus" :key="status.id" :title="status.status"
              :subtitle="status.reason" :time="status.created_at.split('T')[0]" />
          </app-timeline>
        </b-card-text>
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import controller from "@/Controllers/EduContentRoomController";
import config from "@/config/config";
import Auth from "@/Apis/Auth";
import SettingController from "@/Controllers/SettingController";
import VueApexCharts from "vue-apexcharts";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import ApologyController from "@/Controllers/ApologyController";
import SessionAttendanceController from "@/Controllers/SessionAttendanceController";
import ApologyStatusController from "@/Controllers/ApologyStatusController";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";
import OnlineSessionController from "@/Controllers/OnlineSessionController";
import EduContentRoomController from "@/Controllers/EduContentRoomController";

const apologyController = new ApologyController();
export default {
  name: "OnlineSessionDataTable",
  props: ["items", "editItem"],
  components: {
    required,
    ValidationProvider,
    ValidationObserver,
    AppTimeline,
    AppTimelineItem,
    VueApexCharts,
    BCardActions,
  },
  data() {
    return {
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          { key: "checkbox", label: "", sortable: false },
          {
            key: "online_class.id",
            label: this.$i18n.t("site.id"),
            sortable: true,
          },
          {
            key: "online_class.title",
            label: this.$i18n.t("online_session.title"),
            sortable: true,
          },
          {
            key: "room_id",
            label: this.$i18n.t("rooms.room"),
            sortable: true,
          },

          {
            key: "online_class.start_in",
            label: this.$i18n.t("online_session.start_in"),
            sortable: true,
          },
          {
            key: "attendance",
            label: this.$i18n.t("attendance.attendance"),
            sortable: false,
          },
          {
            key: "excuse_request",
            label: this.$i18n.t("attendance.excuse_request"),
            sortable: false,
          },
        ],
      },
      data: {},
      selectAll: false,
      
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      userType: Auth.USER.account_type,
      user: Auth.USER,
      sessionId: 0,
      newData: {},
      userApologies: [],
      apologyStatus: [],
      loadStatus: false,
      att: 0,
      absence: 0,
      donutChart: {
        series: null,
        chartOptions: {
          legend: {
            show: true,
            position: "bottom",
            fontSize: "14px",
            fontFamily: "Montserrat",
          },
          colors: ["#28c76f", "#ea5455"],
          dataLabels: {
            enabled: true,
            formatter(val) {
              // eslint-disable-next-line radix
              return `${parseInt(val)}`;
            },
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  name: {
                    fontSize: "2rem",
                    fontFamily: "Montserrat",
                  },
                  value: {
                    fontSize: "1rem",
                    fontFamily: "Montserrat",
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}`;
                    },
                  },
                  // total: {
                  //   show: true,
                  //   fontSize: "1.5rem",
                  //   label: this.$i18n.t("attendance.attend"),
                  //   formatter() {

                  //     return `${this.att }  %`;
                  //   },
                  // },
                },
              },
            },
          },
          labels: [
            this.$i18n.t("attendance.attend"),
            this.$i18n.t("attendance.absence"),
          ],
          responsive: [
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 380,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
            {
              breakpoint: 576,
              options: {
                chart: {
                  height: 320,
                },
                plotOptions: {
                  pie: {
                    donut: {
                      labels: {
                        show: true,
                        name: {
                          fontSize: "1.5rem",
                        },
                        value: {
                          fontSize: "1rem",
                        },
                        total: {
                          fontSize: "1.5rem",
                        },
                      },
                    },
                  },
                },
                legend: {
                  show: true,
                },
              },
            },
          ],
        },
      },
      room: this.$route.params.roomId,
      userId: this.$route.params.userId,
    };
  },
  async created() {
    this.$mobileTitle.label=this.$i18n.t('attendance.attendance_record'); 

    if (!this.userId) {
      this.userId = Auth.USER.id;
    }
    if (this.room) {
      this.bootstrapTable.fields.splice(6, 1);
    } else {
      const id = localStorage.getItem("eduProgram");
      const room = Auth.ROOM.find((a) => a.edu_program_id == id);
      this.room = room.id;
    }
    this.time = await new SettingController().time();
    // this.userApologies = await apologyController.GetAll({});
    this.$route.params.eduProgramId;



    const session = await new SessionAttendanceController().getStudentAttend({
      user_id: this.userId,
      room_id: this.room,
    });
    this.donutChart.series = [
      session.userSession,
      session.sessions - session.userSession,
    ];
  },
  methods: {
    attend(item) {
      const find = item.online_class.user_session.find((a) => a.user_id == this.userId);
      if (find && find.excuse_id == null) {
        return true;
      }

      return false;
    },

    GetDateTimeZone(date) {
      return Auth.GetDateTimeZone(date);
    },
    checkApologies(item) {      
      const find = this.userApologies.find(
        (a) =>
          a.apologytable_id == item.online_class.id &&
          a.apologytable_type == "App\\OnlineClass" 
      );
      if (find) return true;
      return false;
    },

    async getApologies(item) {
      this.loadStatus = true;
      this.apologyStatus = [];
      this.$refs["modal-primary"].show();

      const apology = this.userApologies.find(
        (a) =>
          a.apologytable_id == item.online_class.id &&
          a.apologytable_type == "App\\OnlineClass" 
      );
      if (!apology) return;
      
      this.apologyStatus = await new ApologyStatusController().GetAll({
        filter: "apology_id|" + apology.id,
      });
      this.loadStatus = false;
    },
    checkExcuse(item) {
      const find = item.online_class.user_session.find((a) => a.user_id == this.userId);
      if (!find) return false;
      if (find.excuse_id !== null) return true;
      return false;
    },

    async submit() {
      this.newData.apologytable_id = this.sessionId;
      this.newData.apologytable_type = "App\\OnlineClass";
      this.newData.user_id = this.userId;
      this.newData.status = "Apply";

      // this.newData.accept = 0;
      const ap = await apologyController.From(this.newData);
      this.$refs.table.refresh();
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    getRecordings(data) {
      new OnlineSessionController().getRecordings(
        data.item.attr.onlline_class_id
      );
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await new EduContentRoomController().GetAll(
        this.apiParamsConverter()
      );
      this.userApologies = await new ApologyController().GetAll({
        filter: "user_id|" + this.userId,
      });
      
      let absence = 0;
      let att = 0;
      // data.data.forEach((element) => {
      //   const find = element.user_session.find(
      //     (a) => a.user_id == this.userId
      //   );
      //   if (!find) absence++;
      //   // else if (find.excuse_id !== null) this.excuse++;
      //   else att++;
      // });
      // if (att != 0) this.att = (att / data.total) * 100;
      // if (absence != 0) this.absence = (absence / data.total) * 100;
      // this.donutChart.series = [this.att, this.absence];
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data = data.data;
      this.load = false;
      return data.data;
    },
    apiParamsConverter() {
      let apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }

      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${this.params.sortDesc ? "desc" : "asc"
          }`;
      }

      if (this.search !== "") {
        apiParams.search = this.search;
      }

      apiParams.datenow = 1;
      // if (this.room == 0) {
      //   apiParams.quran = 1;
      //   //quran_program
      // } else {
      apiParams.filter = "room_id|" + this.room + "&&online_class_id|''|<>";
      // }
      apiParams.with = ["getRoom","onlineClass.userSession"];
      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
  },
};
</script>
